<div class="bulk-approve-modal" *transloco="let t; prefix: 'workOrder'">
  <!-- Header -->
  <div class="modal-header-section">
    <div>
      <h3 class="modal-title">{{ t('modals.bulkApprove.title') }}</h3>
      <p class="modal-subtitle">{{ t('modals.bulkApprove.subtitle') }}</p>
    </div>
    <button class="close-btn" [disabled]="isSubmitting" (click)="onCancel()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15M5 5L15 15" stroke="#4D4749" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <!-- Content -->
  <div class="modal-content-section">
    @for (group of dateGroups; track group.dateLabel) {
      <div class="date-group">
        <p class="date-group-label">{{ group.dateLabel }}</p>

        @for (item of group.items; track item.workOrder.workOrderId) {
          <div class="work-order-card">
            <!-- Card Header -->
            <div class="card-header-row">
              <div class="card-title-section">
                <span class="work-order-number">{{ item.workOrder.workOrderNumber }}</span>
                <span class="priority-badge" [ngClass]="getPriorityClass(item.workOrder.priority)">
                  {{ getPriorityLabel(item.workOrder.priority) }}
                </span>
              </div>
              <button type="button" class="remove-btn" (click)="removeItem(item)" [title]="t('modals.bulkApprove.remove')" [attr.aria-label]="t('modals.bulkApprove.remove')">
                <i class="ph ph-trash"></i>
              </button>
            </div>

            <!-- Card Body -->
            <div class="card-body-row">
              <!-- Left: Work Order Details -->
              <div class="card-details">
                <span
                  class="detail-value asset-name"
                  [ngbTooltip]="item.workOrder.assetName"
                  placement="top"
                  container="body">
                  {{ item.workOrder.assetName }}
                </span>
                <span class="detail-value detail-cost">{{ t('modals.bulkApprove.estCost', { cost: formatCost(item.workOrder.estimatedCost) }) }}</span>
                <span class="detail-value">{{ item.workOrder.workshopName }}</span>
                <span class="detail-value detail-time">{{ t('modals.bulkApprove.estTime', { time: formatTime(item.workOrder.estimatedTime) }) }}</span>
                <span class="detail-value detail-full">{{ WorkOrderServiceTypeLabels[item.workOrder.serviceType] | transloco }}</span>
                <span class="detail-value detail-full detail-reason">{{ item.workOrder.localizedReason || item.workOrder.reason || '-' }}</span>
              </div>

              <!-- Right: Schedule & Technician -->
              <div class="card-fields">
                <div class="field-group">
                  <label class="field-label">{{ t('modals.shared.scheduleDate') }} <span class="required">*</span></label>
                  <app-flatpickr-date-picker
                    [value]="item.scheduledDate"
                    [minDate]="'today'"
                    [dateFormat]="'Y-m-d H:i'"
                    [altFormat]="'d/m/Y H:i'"
                    [placeholder]="t('modals.shared.dateTimePlaceholder')"
                    [enableTime]="true"
                    [time24hr]="true"
                    [required]="true"
                    (valueChange)="onScheduledDateChange(item, $event)">
                  </app-flatpickr-date-picker>
                </div>

                <div class="field-group">
                  <label class="field-label">{{ t('modals.shared.assignedTechnicians') }}<span class="required">*</span></label>
                  <app-technician-multi-select-dropdown
                    [technicians]="getWorkOrderTechnicians(item.workOrder.workOrderId)"
                    [selectedTechnicianIds]="item.technicianIds"
                    [isLoading]="isLoadingTechnicians"
                    (selectedTechnicianIdsChange)="item.technicianIds = $event">
                  </app-technician-multi-select-dropdown>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Footer -->
  <div class="modal-footer-section">
    <button class="btn-cancel" [disabled]="isSubmitting" (click)="onCancel()">{{ 'common.cancel' | transloco }}</button>
    <button class="btn-approve" [disabled]="!isValid || isSubmitting" (click)="onApproveAll()">
      @if (isSubmitting) {
        <span class="spinner-border"></span>
      } @else {
        <span>{{ t('modals.bulkApprove.approveAll') }}</span>
      }
    </button>
  </div>
</div>